module.exports = __webpack_public_path__ + "media/application/images/brand/logo--horizontal--on-white-3163994af6584f66e6e2d6ae950255f4.png";